import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import * as Swiper from 'swiper/dist/js/swiper.js';
import '../../interfaces/slider.interface';
import './how-to-guide-vertical.component.scss';
import * as $ from 'jquery';
var HowToGuideVertical = /** @class */ (function (_super) {
    tslib_1.__extends(HowToGuideVertical, _super);
    function HowToGuideVertical(element) {
        return _super.call(this, element) || this;
    }
    HowToGuideVertical.prototype.init = function () {
        var _this = this;
        this.slides = Array.from(this.element.querySelectorAll('.swiper-slide	'));
        this.sliderItems = Number(this.element.getAttribute('data-items'));
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderPaginationContainer = this.element.querySelector('.how-to-guide-vertical__pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderButtons = Array.from(this.element.querySelectorAll('.campaign-components__button'));
        this.windowWidth = document.documentElement.clientWidth;
        this.breakpoints = {};
        this.sliderConfig = {
            fadeEffect: {
                crossFade: true
            },
            effect: 'fade',
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            breakpoints: this.breakpoints,
            pagination: {
                el: this.sliderPagination,
                clickable: true,
                bulletActiveClass: 'swiper-pagination-bullet-active',
                bulletClass: 'swiper-pagination-bullet',
                renderBullet: function (index, className) {
                    if (index < 5) {
                        return '<span class="' + className + '" data-pagination-index="' + index + '" tabindex="0" role="button"></span>';
                    }
                    else {
                        return '<span class="' + className + ' d-none" data-pagination-index="' + index + '" tabindex="0" role="button"></span>';
                    }
                }
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        this.sliderComponent = new Swiper(this.sliderContainer, this.sliderConfig);
        this.sliderComponent.on('slideChange', function (event) {
            var index = _this.sliderComponent.realIndex;
            _this.recreatePagination(index);
        });
        this.resizePagination();
        window.addEventListener('resize', function () {
            _this.resizePagination();
        });
    };
    HowToGuideVertical.prototype.bindEvents = function () {
        var _this = this;
        $('.how-to-guide-vertical').on('click touch', '.pagination__nav--prev-end', function (event) {
            _this.sliderComponent.slideTo(0, true);
        });
        $('.how-to-guide-vertical').on('click touch', '.pagination__nav--next-end', function (event) {
            _this.sliderComponent.slideTo((_this.slides.length - 1), true);
        });
    };
    HowToGuideVertical.prototype.recreatePagination = function (index) {
        if (index === void 0) { index = 0; }
        console.log();
        var slides = this.slides.length;
        // arrows
        if (index === 0) {
            this.sliderPrev.classList.add('swiper-button-disabled');
            this.sliderNext.classList.remove('swiper-button-disabled');
        }
        else if (index === (slides - 1)) {
            this.sliderPrev.classList.remove('swiper-button-disabled');
            this.sliderNext.classList.add('swiper-button-disabled');
        }
        else {
            this.sliderPrev.classList.remove('swiper-button-disabled');
            this.sliderNext.classList.remove('swiper-button-disabled');
        }
        // buttons
        var buttons = Array.from(this.element.querySelectorAll('.swiper-pagination-bullet'));
        buttons.forEach(function (button) {
            var buttonIndex = button.getAttribute('data-pagination-index');
            var buttonIndexNumber = parseInt(buttonIndex);
            if (index === 0) {
                if (buttonIndexNumber === 0 || buttonIndexNumber === 1 || buttonIndexNumber === 2 || buttonIndexNumber === 3 || buttonIndexNumber === 4) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
            else if (index === (slides - 1)) {
                if (buttonIndexNumber === index || buttonIndexNumber === (index - 1) || buttonIndexNumber === (index - 2) || buttonIndexNumber === (index - 3) || buttonIndexNumber === (index - 4)) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
            else if (index === 5 || index === 10 || index === 15 || index === 20) {
                if (buttonIndexNumber === index || buttonIndexNumber === (index + 1) || buttonIndexNumber === (index + 2) || buttonIndexNumber === (index + 3) || buttonIndexNumber === (index + 4)) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
            else if (index === 4 || index === 9 || index === 14 || index === 19) {
                if (buttonIndexNumber === index || buttonIndexNumber === (index - 1) || buttonIndexNumber === (index - 2) || buttonIndexNumber === (index - 3) || buttonIndexNumber === (index - 4)) {
                    button.classList.remove('d-none');
                }
                else {
                    button.classList.add('d-none');
                }
            }
        });
    };
    HowToGuideVertical.prototype.resizePagination = function () {
        if (window.screen.width < 769) {
            var getActiveSlide = this.element.querySelector('.swiper-slide-active');
            var getImage = getActiveSlide.querySelector('.how-to-guide-vertical__item--image');
            var getImageHeight = getImage.clientHeight;
            this.sliderPaginationContainer.style.height = getImageHeight + 'px';
        }
        else {
            this.sliderPaginationContainer.style.height = 'auto';
        }
    };
    return HowToGuideVertical;
}(Base));
export { HowToGuideVertical };



//////////////////
// WEBPACK FOOTER
// ./components/how-to-guide-vertical/how-to-guide-vertical.component.ts
// module id = 587
// module chunks = 0